import httpService from "@/utils/services/http_service";

export default {
    /**
     * @author: liuxiangmin
     * date: 2020-03-02
     *  管理员列表
     */

    //  获取大屏配置数据列表
    async getBigScreenList(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_list',
        data
      )
    },

    //  获取大屏配置(字段)数据列表
    async getBigScreenFieldsList(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_field_list',
        data
      )
    },

    //  新增大屏配置数据
    async addBigScreenData(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_create',
        data
      )
    },

    //  新增大屏(字段)配置
    async addBigScreenFieldsData(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_field_create',
        data
      )
    },

    //  修改大屏(字段)配置
    async editBigScreenFieldsData(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_field_edit',
        data
      )
    },


     /**
     * @author: lafitewu
     * date: 2020-05-14
     *  大屏属性配置
     */

    //  select地区列表
    async adminAreaList(data={}) {
      return httpService.post(
        '/api.php?do=admin_area_list',
        data
      )
    },

    //  select项目列表
    async companyList(data={}) {
      return httpService.post(
        '/api.php?do=admin_company_list',
        data
      )
    },

    //  大屏配置修改
    async settingEdit(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_edit',
        data
      )
    },

    // 2021.11.05 湘企新增，大屏分类列表
    async boardConfigCategoryList(data={}) {
      return httpService.post(
        '/api.php?do=admin_board_config_category_list',
        data
      )
    },
}